import { render, staticRenderFns } from "./voice-stats-general-table.vue?vue&type=template&id=472ff7d6&"
import script from "./voice-stats-general-table.vue?vue&type=script&lang=js&"
export * from "./voice-stats-general-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports